class Quiz {
  constructor() {
    this.currentStep = 1;

    this.totalSteps =
      Number(
        document.querySelector(
          '.quiz-progress__text'
        )?.dataset.totalSteps
      ) || 6;

    this.steps = document.querySelectorAll(
      '.quiz-content'
    );
    this.progressFill = document.querySelector(
      '.quiz-progress__fill'
    );
    this.currentStepText = document.querySelector(
      '.current-step'
    );
    this.totalStepText = document.querySelector(
      '.total-step'
    );
    this.progressWrapper =
      document.querySelector(
        '.quiz-progress-wrapper'
      );
    this.resultContainer =
      document.querySelector('.quiz-result');

    this.answers = {};
    this.resultMappings =
      this.getResultMappings();
    this.moneyData = this.getMoneyData();

    this.init();
  }

  init() {
    if (this.totalStepText) {
      this.totalStepText.textContent =
        this.totalSteps;
    }

    this.initDefaultAnswers();
    document.dispatchEvent(
      new CustomEvent(
        'quiz:pack-change',
        {
          detail: {
            packQuantity:
              this.getPackQuantity()
          }
        }
      )
    );
    this.bindEvents();
    this.showStep(this.currentStep);
  }

  bindEvents() {
    document.addEventListener(
      'change',
      (event) => {
        const input = event.target.closest(
          '.quiz-option-input'
        );

        if (!input) return;

        this.selectOption(input);
      }
    );

    document.addEventListener(
      'click',
      async (event) => {
        const nextBtn = event.target.closest(
          '[data-quiz-next]'
        );
        const prevBtn = event.target.closest(
          '[data-quiz-prev]'
        );
        const gotoBtn = event.target.closest(
          '[data-quiz-goto]'
        );
        const addToCartBtn =
          event.target.closest(
            '.quiz-add-cart'
          );

        if (nextBtn) {
          this.nextStep();
        }

        if (prevBtn) {
          this.prevStep();
        }

        if (gotoBtn) {
          this.goToStep(
            gotoBtn.dataset.quizGoto
          );
        }

        if (addToCartBtn) {
          await this.handleAddToCart(
            addToCartBtn.dataset.productId,
            addToCartBtn
          );
        }
      }
    );
  }

  selectOption(input) {
    const answer =
      this.setAnswerFromInput(input);

    if (
      Number(
        input
          .closest('[data-step]')
          ?.dataset.step
      ) === 5
    ) {
      document.dispatchEvent(
        new CustomEvent(
          'quiz:pack-change',
          {
            detail: {
              packQuantity:
                answer.packQuantity
            }
          }
        )
      );
    }
  }

  setAnswerFromInput(input) {
    const step = input.closest('[data-step]');

    if (!step) return null;

    const stepNumber = Number(
      step.dataset.step
    );
    const answer = {
      value: input.value,
      resultType:
        input.dataset.resultType ||
        null
    };

    if (stepNumber === 5) {
      answer.packQuantity =
        this.extractPackQuantity(
          input.value
        );
    }

    this.answers[String(stepNumber)] =
      answer;

    return answer;
  }

  initDefaultAnswers() {
    document
      .querySelectorAll(
        '.quiz-option-input:checked'
      )
      .forEach((input) => {
        this.setAnswerFromInput(input);
      });
  }

  extractPackQuantity(value) {
    const match = String(
      value || ''
    ).match(/(\d+)/);

    return Number(match?.[1] || 0);
  }

  getPackQuantity() {
    const savedQuantity = Number(
      this.answers['5']
        ?.packQuantity
    );

    if (savedQuantity > 0) {
      return savedQuantity;
    }

    return (
      this.extractPackQuantity(
        document.querySelector(
          'input[name="quiz-step-5"]:checked'
        )?.value
      ) || 4
    );
  }

  selectStep6() {
    const size =
      document.querySelector(
        'input[name="quiz-size"]:checked'
      )?.value || null;

    const colors = [
      ...document.querySelectorAll(
        '[data-color-quantity-input]'
      )
    ]
      .map((input) => ({
        label: input.dataset.color,
        value:
          input.dataset.colorValue,
        quantity: Number(
          input.value || 0
        )
      }))
      .filter(
        (color) => color.quantity > 0
      );

    const packQuantity =
      this.getPackQuantity();
    const selectedTotal =
      colors.reduce(
        (total, color) =>
          total + color.quantity,
        0
      );

    if (!size) {
      alert(
        'Please choose your size.'
      );
      return false;
    }

    if (selectedTotal !== packQuantity) {
      alert(
        `Please choose exactly ${packQuantity} pairs for your pack.`
      );
      return false;
    }

    this.answers.step6 = {
      size,
      colors,
      packQuantity
    };

    return true;
  }

  showStep(stepNumber) {
    this.currentStep = Number(
      stepNumber
    );

    this.steps.forEach((step) => {
      step.classList.remove('active');
    });

    const currentStep =
      document.querySelector(
        `.quiz-content[data-step="${this.currentStep}"]`
      );

    if (currentStep) {
      currentStep.classList.add(
        'active'
      );
    }

    this.resultContainer?.classList.add(
      'hidden'
    );
    this.progressWrapper?.removeAttribute(
      'hidden'
    );

    this.updateProgress();

    document.dispatchEvent(
      new CustomEvent(
        'quiz:step-change',
        {
          detail: {
            step: this.currentStep,
            packQuantity:
              this.getPackQuantity()
          }
        }
      )
    );
  }

  updateProgress() {
    const percent =
      (this.currentStep /
        this.totalSteps) *
      100;

    if (this.progressFill) {
      this.progressFill.style.width = `${percent}%`;
    }

    if (this.currentStepText) {
      this.currentStepText.textContent =
        this.currentStep;
    }
  }

  nextStep() {
    const currentStepEl =
      document.querySelector(
        '.quiz-content.active'
      );
    const stepNumber = Number(
      currentStepEl?.dataset.step
    );
    const isStep6 =
      currentStepEl?.classList.contains(
        'quiz-step-6'
      );
    const currentAnswer =
      this.answers[String(stepNumber)];

    if (isStep6) {
      if (!this.selectStep6()) {
        return;
      }
    } else if (!currentAnswer) {
      alert(
        'Please select an option.'
      );
      return;
    }

    if (
      this.currentStep >=
      this.totalSteps
    ) {
      this.showResult();
      return;
    }

    this.showStep(
      this.currentStep + 1
    );
  }

  prevStep() {
    if (this.currentStep <= 1) return;

    this.showStep(
      this.currentStep - 1
    );
  }

  goToStep(stepNumber) {
    const nextStep = Number(
      stepNumber
    );

    if (
      !Number.isFinite(nextStep) ||
      nextStep < 1 ||
      nextStep > this.totalSteps
    ) {
      return;
    }

    this.showStep(nextStep);
  }

  calculateWinner() {
    const scores = {};

    Object.entries(this.answers).forEach(
      ([key, answer]) => {
        if (key === 'step6') {
          return;
        }

        if (!answer?.resultType) {
          return;
        }

        scores[answer.resultType] =
          (scores[
            answer.resultType
          ] || 0) + 1;
      }
    );

    const sorted = Object.entries(
      scores
    ).sort(
      (a, b) => b[1] - a[1]
    );

    return sorted[0]?.[0] || null;
  }

  getWinnerProducts() {
    const winner =
      this.calculateWinner();

    return (
      this.resultMappings[
        winner
      ] || []
    );
  }

  getSelectedSize() {
    return (
      this.answers.step6?.size ||
      document.querySelector(
        'input[name="quiz-size"]:checked'
      )?.value ||
      null
    );
  }

  getSelectedColors() {
    return (
      this.answers.step6?.colors ||
      []
    );
  }

  buildPackItems(product) {
    const size =
      this.getSelectedSize();

    return this.getSelectedColors().map(
      (selection) => ({
        ...selection,
        variant: this.findVariant(
          product,
          size,
          selection.label
        )
      })
    );
  }

  findVariant(
    product,
    size,
    color
  ) {
    if (
      !product?.variants?.length ||
      !size ||
      !color
    ) {
      return null;
    }

    return (
      product.variants.find(
        (variant) =>
          variant.available &&
          variant.options.includes(
            size
          ) &&
          variant.options.includes(
            color
          )
      ) || null
    );
  }

  getPackTotal(product, packItems) {
    return packItems.reduce(
      (total, item) =>
        total +
        (Number(
          item.variant?.price_cents ??
            product.price_cents ??
            0
        ) *
          item.quantity),
      0
    );
  }

  getMoneyData() {
    const el = document.querySelector(
      '#QuizMoneyData'
    );

    if (!el) {
      return {};
    }

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error(
        'Invalid QuizMoneyData JSON',
        error
      );
      return {};
    }
  }

  formatMoney(cents) {
    const amount = Number(
      cents || 0
    );

    if (
      window.Shopify &&
      typeof window.Shopify
        .formatMoney ===
        'function' &&
      this.moneyData.moneyFormat
    ) {
      return window.Shopify.formatMoney(
        amount,
        this.moneyData.moneyFormat
      );
    }

    if (this.moneyData.currency) {
      return new Intl.NumberFormat(
        undefined,
        {
          style: 'currency',
          currency:
            this.moneyData.currency
        }
      ).format(amount / 100);
    }

    return (amount / 100).toFixed(2);
  }

  escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  showResult() {
    const products =
      this.getWinnerProducts();

    this.progressWrapper?.setAttribute(
      'hidden',
      'hidden'
    );

    this.steps.forEach((step) => {
      step.classList.remove('active');
    });

    this.renderProducts(products);

    this.resultContainer?.classList.remove(
      'hidden'
    );
  }

  renderProducts(products) {
    const container =
      document.querySelector(
        '.quiz-result-products'
      );

    if (!container) return;

    if (!products.length) {
      container.innerHTML = `
        <div class="quiz-result-empty">
          No matching products found.
        </div>
      `;
      return;
    }

    const size =
      this.getSelectedSize();
    const packQuantity =
      this.getPackQuantity();

    container.innerHTML = products
      .map((product) => {
        const packItems =
          this.buildPackItems(
            product
          );
        const totalPairs =
          packItems.reduce(
            (total, item) =>
              total +
              item.quantity,
            0
          );
        const totalPrice =
          this.getPackTotal(
            product,
            packItems
          );
        const unavailableItems =
          packItems.filter(
            (item) => !item.variant
          );
        const uniqueColorCount =
          packItems.length;
        const unitPrice = Number(
          packItems[0]?.variant
            ?.price_cents ??
            product.price_cents ??
            0
        );
        const canBuy =
          Boolean(size) &&
          totalPairs ===
            packQuantity &&
          unavailableItems.length ===
            0;
        const colorMarkup =
          packItems.length
            ? packItems
                .map(
                  (item) => `
                    <li class="quiz-pack-summary__color-item">
                      <span class="quiz-pack-summary__color-meta">
                        <span
                          class="quiz-pack-summary__swatch"
                          style="background:${item.value};"
                          title="${this.escapeHtml(item.label)}"
                        ></span>
                        ${this.escapeHtml(item.label)}
                      </span>
                      <strong>${item.quantity}x</strong>
                    </li>
                  `
                )
                .join('')
            : `
              <li class="quiz-pack-summary__color-item">
                No colors selected.
              </li>
            `;
        const warningMarkup =
          unavailableItems.length
            ? `
              <p class="quiz-pack-summary__warning">
                Some selected colors are unavailable in size ${this.escapeHtml(size)}. Please edit your selection before buying.
              </p>
            `
            : '';

        return `
          <article class="quiz-pack-summary">
            <a class="quiz-pack-summary__media" href="${product.url}" aria-label="${this.escapeHtml(product.title)}">
              <img
                src="${product.image}"
                alt="${this.escapeHtml(product.title)}"
                loading="lazy"
              >
            </a>
            <div class="quiz-pack-summary__content">
              <p class="quiz-pack-summary__eyebrow">
                ${packQuantity}-pair configured pack
              </p>
              <h3 class="quiz-pack-summary__title">
                <a href="${product.url}">
                  ${this.escapeHtml(product.title)}
                </a>
              </h3>
              <div class="quiz-pack-summary__price">
                <strong>${this.formatMoney(totalPrice)}</strong>
                <span>${this.formatMoney(unitPrice)} each</span>
              </div>
              <dl class="quiz-pack-summary__details">
                <div>
                  <dt>Pack size</dt>
                  <dd>${packQuantity} pairs</dd>
                </div>
                <div>
                  <dt>Total selected</dt>
                  <dd>${totalPairs} pairs</dd>
                </div>
                <div>
                  <dt>Size</dt>
                  <dd>${this.escapeHtml(size)}</dd>
                </div>
                <div>
                  <dt>Colors</dt>
                  <dd>${uniqueColorCount} selected</dd>
                </div>
              </dl>
              <div class="quiz-pack-summary__colors">
                <p class="quiz-pack-summary__label">
                  Your color mix
                </p>
                <ul class="quiz-pack-summary__color-list">
                  ${colorMarkup}
                </ul>
              </div>
              ${warningMarkup}
              <div class="quiz-pack-summary__actions">
                <button
                  type="button"
                  class="button button--secondary quiz-prev"
                  data-quiz-goto="6"
                >
                  Edit selections
                </button>
                <button
                  type="button"
                  class="quiz-add-cart button button--primary quiz-next"
                  data-product-id="${product.id}"
                  ${
                    canBuy
                      ? ''
                      : 'disabled'
                  }
                >
                  Buy now
                </button>
              </div>
              <div class="more-information">
                <a href="${product.url}">View product details</a>
              </div>
            </div>
          </article>
        `;
      })
      .join('');
  }

  async handleAddToCart(
    productId,
    button
  ) {
    const product =
      this.getWinnerProducts().find(
        (item) =>
          String(item.id) ===
          String(productId)
      );

    if (!product) {
      return;
    }

    const packItems =
      this.buildPackItems(product);
    const validItems =
      packItems.filter(
        (item) => item.variant
      );
    const totalPairs =
      validItems.reduce(
        (total, item) =>
          total + item.quantity,
        0
      );
    const packQuantity =
      this.getPackQuantity();

    if (
      totalPairs !== packQuantity ||
      validItems.length !==
        packItems.length
    ) {
      alert(
        'Please review your pack before adding it to cart.'
      );
      return;
    }

    const cart =
      document.querySelector(
        'cart-drawer'
      );
    const formData =
      new FormData();
    const originalLabel =
      button?.textContent;

    validItems.forEach(
      (item, index) => {
        formData.append(
          `items[${index}][id]`,
          item.variant.id
        );
        formData.append(
          `items[${index}][quantity]`,
          item.quantity
        );
      }
    );

    if (cart) {
      cart
        .getSectionsToRender()
        .forEach((section) => {
          formData.append(
            'sections',
            section.id
          );
        });
      formData.append(
        'sections_url',
        window.location.pathname
      );
      cart.setActiveElement(
        document.activeElement
      );
    }

    try {
      if (button) {
        button.disabled = true;
        button.textContent =
          'Adding...';
      }

      const config =
        typeof fetchConfig ===
        'function'
          ? fetchConfig(
              'javascript'
            )
          : {
              method: 'POST',
              headers: {
                Accept:
                  'application/json'
              }
            };

      config.headers =
        config.headers || {};
      config.headers[
        'X-Requested-With'
      ] = 'XMLHttpRequest';
      delete config.headers[
        'Content-Type'
      ];
      config.body = formData;

      const response = await fetch(
        window.routes
          ?.cart_add_url ||
          '/cart/add.js',
        config
      );
      const data =
        await response.json();

      if (
        !response.ok ||
        data.status
      ) {
        throw new Error(
          data.description ||
            'Unable to add the configured pack to cart.'
        );
      }

      if (
        await this.openMonsterCart()
      ) {
        return;
      }

      if (cart) {
        const drawerOpened =
          this.renderCartDrawerFromResponse(
            cart,
            data
          ) ||
          (await this.refreshCartDrawer(
            cart
          ));

        if (drawerOpened) {
          return;
        }

        window.location.href =
          window.routes?.cart_url ||
          '/cart';
        return;
      }

      if (
        typeof publish ===
          'function' &&
        typeof PUB_SUB_EVENTS !==
          'undefined'
      ) {
        publish(
          PUB_SUB_EVENTS.cartUpdate,
          { source: 'quiz' }
        );
      }

      window.location.href =
        window.routes?.cart_url ||
        '/cart';
    } catch (error) {
      console.error(
        'Add to cart failed',
        error
      );
      alert(
        error.message ||
          'Unable to add the configured pack to cart.'
      );
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent =
          originalLabel;
      }
    }
  }

  async fetchCartState() {
    const cartUrl = new URL(
      window.routes?.cart_url ||
      '/cart',
      window.location.origin
    );

    cartUrl.pathname = `${cartUrl.pathname}.js`;
    cartUrl.searchParams.set(
      '_',
      Date.now().toString()
    );

    const cartResponse = await fetch(
      cartUrl.toString(),
      {
        cache: 'no-store',
        headers: {
          Accept:
            'application/json'
        }
      }
    );

    if (!cartResponse.ok) {
      throw new Error(
        'Unable to refresh cart state.'
      );
    }

    return cartResponse.json();
  }

  async fetchSections(
    sectionIds,
    routePath = window.location.pathname
  ) {
    const sectionsUrl = new URL(
      routePath,
      window.location.origin
    );

    sectionsUrl.searchParams.set(
      'sections',
      sectionIds.join(',')
    );
    sectionsUrl.searchParams.set(
      '_',
      Date.now().toString()
    );

    const response = await fetch(
      sectionsUrl.toString(),
      {
        cache: 'no-store',
        headers: {
          Accept:
            'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to refresh cart sections.'
      );
    }

    return response.json();
  }

  async fetchSectionHtml(
    sectionId,
    routePath = window.location.pathname
  ) {
    const sectionUrl = new URL(
      routePath,
      window.location.origin
    );

    sectionUrl.searchParams.set(
      'section_id',
      sectionId
    );
    sectionUrl.searchParams.set(
      '_',
      Date.now().toString()
    );

    const response = await fetch(
      sectionUrl.toString(),
      {
        cache: 'no-store',
        headers: {
          Accept: 'text/html'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        `Unable to refresh ${sectionId}.`
      );
    }

    return response.text();
  }

  isMonsterCartActive() {
    return Boolean(
      document.querySelector(
        'script[src*="/cart_renderer."]'
      ) ||
        document.querySelector(
          'monster-cart-wrapper'
        )
    );
  }

  getMonsterCartHandler() {
    if (
      typeof window.monster_refresh ===
      'function'
    ) {
      return window.monster_refresh.bind(
        window
      );
    }

    if (
      typeof monster_refresh ===
      'function'
    ) {
      return monster_refresh;
    }

    if (
      typeof window.openCart ===
      'function'
    ) {
      return window.openCart.bind(
        window
      );
    }

    return null;
  }

  async openMonsterCart() {
    if (!this.isMonsterCartActive()) {
      return false;
    }

    const attemptDelays = [
      0, 250, 750, 1500, 2500
    ];

    for (const delay of attemptDelays) {
      if (delay) {
        await new Promise(
          (resolve) => {
            window.setTimeout(
              resolve,
              delay
            );
          }
        );
      }

      const handler =
        this.getMonsterCartHandler();

      if (!handler) {
        continue;
      }

      try {
        await Promise.resolve(
          handler()
        );
        return true;
      } catch (error) {
        console.warn(
          'Quiz monster cart open retry',
          error
        );
      }
    }

    return false;
  }

  getSectionMarkup(
    html,
    selector,
    fallbackSelector
  ) {
    if (!html) {
      return '';
    }

    const parsedDocument =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );
    const directMatch =
      parsedDocument.querySelector(
        selector
      );

    if (directMatch) {
      return directMatch.innerHTML;
    }

    if (fallbackSelector) {
      const fallbackMatch =
        parsedDocument.querySelector(
          fallbackSelector
        );

      if (fallbackMatch) {
        const nestedMatch =
          fallbackMatch.querySelector(
            selector
          );

        if (nestedMatch) {
          return nestedMatch.innerHTML;
        }
      }
    }

    return '';
  }

  renderCartDrawerFromResponse(
    cart,
    state
  ) {
    if (
      !cart ||
      !state?.sections?.[
        'cart-drawer'
      ]
    ) {
      return false;
    }

    try {
      cart.classList.remove(
        'is-empty'
      );
      cart.renderContents(state);
      return true;
    } catch (error) {
      console.warn(
        'Quiz cart drawer render fallback',
        error
      );

      return false;
    }
  }

  getCartStateId(cartState) {
    if (cartState?.items?.length) {
      return (
        cartState.items[
          cartState.items.length - 1
        ]?.id || cartState.id
      );
    }

    return cartState?.id;
  }

  async refreshCartDrawer(cart) {
    try {
      const [
        cartStateResult,
        sectionsResult,
        drawerHtmlResult,
        headerHtmlResult
      ] = await Promise.allSettled([
        this.fetchCartState(),
        this.fetchSections([
          'cart-drawer',
          'cart-icon-bubble'
        ]),
        this.fetchSectionHtml(
          'cart-drawer'
        ),
        this.fetchSectionHtml(
          'header'
        )
      ]);
      const cartState =
        cartStateResult.status ===
        'fulfilled'
          ? cartStateResult.value
          : null;
      const sections =
        sectionsResult.status ===
        'fulfilled'
          ? sectionsResult.value
          : null;
      const standaloneDrawerHtml =
        drawerHtmlResult.status ===
        'fulfilled'
          ? drawerHtmlResult.value
          : '';
      const standaloneHeaderHtml =
        headerHtmlResult.status ===
        'fulfilled'
          ? headerHtmlResult.value
          : '';

      if (
        sections &&
        this.renderCartDrawerFromResponse(
          cart,
          {
            id: this.getCartStateId(
              cartState
            ),
            sections
          }
        )
      ) {
        return true;
      }

      const drawerTarget =
        cart.querySelector(
          '#CartDrawer'
        );
      const bubbleTarget =
        document.getElementById(
          'cart-icon-bubble'
        );
      const drawerMarkup =
        this.getSectionMarkup(
          sections?.[
            'cart-drawer'
          ],
          '#CartDrawer',
          'cart-drawer'
        ) ||
        this.getSectionMarkup(
          standaloneDrawerHtml,
          '#CartDrawer',
          'cart-drawer'
        );
      const bubbleMarkup =
        this.getSectionMarkup(
          sections?.[
            'cart-icon-bubble'
          ],
          '#cart-icon-bubble',
          '.shopify-section'
        ) ||
        this.getSectionMarkup(
          standaloneHeaderHtml,
          '#cart-icon-bubble',
          '.shopify-section'
        );

      if (!drawerMarkup) {
        console.warn(
          'Quiz cart drawer markup unavailable',
          {
            sections,
            hasStandaloneDrawer:
              Boolean(
                standaloneDrawerHtml
              ),
            hasStandaloneHeader:
              Boolean(
                standaloneHeaderHtml
              )
          }
        );

        return false;
      }

      if (drawerTarget) {
        drawerTarget.innerHTML =
          drawerMarkup;
      }

      if (bubbleTarget && bubbleMarkup) {
        bubbleTarget.innerHTML =
          bubbleMarkup;
      }

      cart.classList.toggle(
        'is-empty',
        cartState?.item_count === 0
      );
      cart
        .querySelector(
          'cart-drawer-items'
        )
        ?.classList.toggle(
          'is-empty',
          cartState?.item_count === 0
        );

      const drawerInner =
        cart.querySelector(
          '.drawer__inner'
        );
      const overlay =
        cart.querySelector(
          '#CartDrawer-Overlay'
        );

      if (
        drawerInner &&
        drawerInner.classList.contains(
          'is-empty'
        ) &&
        cartState?.item_count > 0
      ) {
        drawerInner.classList.remove(
          'is-empty'
        );
      }

      overlay?.addEventListener(
        'click',
        cart.close.bind(cart)
      );

      cart.setActiveElement(
        document.getElementById(
          'cart-icon-bubble'
        ) || document.activeElement
      );
      cart.open();
      return true;
    } catch (error) {
      console.warn(
        'Quiz cart drawer refresh fallback',
        error
      );

      return false;
    }
  }

  getResultMappings() {
    const el = document.querySelector(
      '#QuizResultMappings'
    );

    if (!el) return {};

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error(
        'Invalid QuizResultMappings JSON',
        error
      );

      return {};
    }
  }
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    window.quizApp = new Quiz();
  }
);
